module.exports = __webpack_public_path__ + "static/Logoico-a57822ed6a48a040b04a58cf4424745b.png";